/**
 * BookingStatusHistoryService
 * Service for managing booking status history records
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for booking status history CRUD operations
 */
export class BookingStatusHistoryService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BookingStatusHistoryService.DEFAULT_SERVICE_PATH,
            basePath: BookingStatusHistoryService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
BookingStatusHistoryService.DEFAULT_SERVICE_PATH = 'booking-management';
BookingStatusHistoryService.BASE_PATH = 'api/booking-status-history';
//# sourceMappingURL=BookingStatusHistoryService.js.map